
export const SUPER = 'SUPER';
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const READ = 'READ';
